  <template>
  <va-card :title="title">
    <div class="row align--center mb-1">
      <div class="flex xs12 sm6">
        <va-input class="ma-0" :value="searchTerm" :placeholder="$t('tables.searchByName')" @input="search">
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>

      <div class="flex xs12 sm6">
        <div class="d-flex justify--end">
          <va-button-toggle outline v-model="bFilterIssues" :options="filterIssues" style="max-width: 100%" />
        </div>
      </div>
    </div>

    <div v-if="loading" class="hiq-spinner-div">
      <img class="hiq-spinner" src="/assets/rpspinnerb.png" />
    </div>
    <va-data-table
      ref="datatable"
      :fields="fields"
      :data="filteredData"
      :selection-id="currentSelId"
      no-pagination
      @row-clicked="rowClicked"
      @row-dblclicked="rowDoubleClicked"
      @cell-clicked="cellClicked"
      clickable
      no-data-label="No matches"
      hoverable
      ext-link-field="__slot:extlink"
      v-if="!loading"
    >
      <template slot="icon" slot-scope="props">
        <font-awesome-icon :icon="getIconName(props.rowData.weather)" class="font-awesome-icon" />
      </template>

      <template slot="status" slot-scope="{ rowData }">
        <va-badge :color="getStatusColor(rowData)">{{ getStatusText(rowData) }}</va-badge>
      </template>

      <template slot="power" slot-scope="{ rowData }"><span v-html=formatPower(rowData)></span></template>

      <template slot="details" slot-scope="{ rowData }">{{ formatDetails(rowData) }}</template>

      <!-- <template slot="goto" slot-scope="props">
        <router-link :to="buildGotoLink(props)">
          <font-awesome-icon icon="angle-double-right" class="font-awesome-icon" />
        </router-link>
      </template> -->

      <template slot="extlink" slot-scope="{ rowData }">
        <font-awesome-icon v-if="rowData.paid_thru_expired" icon="ban" class="extlink-unpaid" title="Unpaid" />
        <font-awesome-icon v-else icon="arrow-circle-right" class="extlink" title="More details" />
      </template>

      <!-- unused: -->
      <!-- <template slot="actions" slot-scope="props">
        <va-button small outline color="success" icon="fa fa-check" class="ma-0" @click="resolveUser(props.rowData)">{{ $t('dashboard.table.resolve') }}</va-button>
      </template> -->
    </va-data-table>
  </va-card>
</template>

<script>
import { debounce } from 'lodash'
// import data from '../markup-tables/data.json'
import hiqapi from '@/hiqapi/hiqapi'
import { getInvStateColor, formatPower, formatDate } from '@/common'

export default {
  props: ['location'],
  data() {
    return {
      // siteData: [{ 'name': 'Loading...' }],
      loading: true,
      searchTerm: null,
      bFilterIssues: 0,
      listData: [], // list of currentListType
      currentListType: null, // type of list loaded: 'sites', 'gws',   'invs'
      currentListId: -1, // id of list parent:    null,   siteId,  gwSerial  // -1 means none loaded
      currentSelId: null,
    }
  },
  watch: {
    location: {
      immediate: true, // so this is called at startup (in addition to subsequent changes)
      deep: true,
      handler(val, oldVal) {
        console.log(`DT-LOCATION will get data for site=${val.siteId} gw=${val.gwSerial} type=${val.listType} sel=${val.selectedId} : `, val)
        if (val.siteId === null) {
          val.siteId = 0
        }

        // clear any search term
        this.searchTerm = ''

        if (val.listType === val.TYPE_INVS) {
          if (this.currentListType === val.listType && this.currentListId === val.gwSerial) {
            if (!val.selectedId && this.listData) {
              this.rowClicked(this.listData[0]) // nothing selected, but we already have the data, so just select the first item
              return
            }
            console.log(`    DT INV list for gw ${val.gwSerial} already loaded. Selecting inv ${val.selectedId}`)
            // this.$refs.datatable.selectRow(val.selectedId)
            this.announceNewSelection(null, val.selectedId)
          } else {
            console.log(`    DT INV list for gw ${val.gwSerial} needs to be loaded, then selecting inv ${val.selectedId}`)
            this.loading = true
            hiqapi.getcb(`/inverters?last_gw_serial=${val.gwSerial}&site_id=${val.siteId}&summary=true`, this.setData)
            // I _THINK_ this can be done here (it might need to be done after the data is received)
            this.currentListType = val.listType
            this.currentListId = val.gwSerial
          }
        } else if (val.listType === val.TYPE_GWS) {
          if (this.currentListType === val.listType && this.currentListId === val.siteId) {
            if (!val.selectedId && this.listData) {
              this.rowClicked(this.listData[0]) // nothing selected, but we already have the data, so just select the first item
              return
            }
            console.log(`    DT GW list for site ${val.siteId} already loaded. Selecting inv ${val.selectedId}`)
            // this.$refs.datatable.selectRow(val.selectedId)
            this.announceNewSelection(null, val.selectedId)
          } else {
            console.log(`    DT GW list for site ${val.siteId} needs to be loaded, then selecting inv ${val.selectedId}`)
            this.loading = true
            hiqapi.getcb(`/gateways?site_id=${val.siteId}&summary=true`, this.setData)
            // I _THINK_ this can be done here (it might need to be done after the data is received)
            this.currentListType = val.listType
            this.currentListId = val.siteId
          }
        } else if (val.listType === val.TYPE_SITES) {
          if (this.currentListType === val.listType) {
            if (!val.selectedId && this.listData) {
              this.rowClicked(this.listData[0]) // nothing selected, but we already have the data, so just select the first item
              return
            }
            console.log(`    DT SITE list already loaded. Selecting inv ${val.selectedId}`)
            // this.$refs.datatable.selectRow(val.selectedId)
            this.announceNewSelection(null, val.selectedId)
          } else {
            console.log(`    DT SITE list needs to be loaded, then selecting inv ${val.selectedId}`)
            this.loading = true
            hiqapi.getcb('/sites?summary=true', this.setData)
            // hiqapi.getcb('/sites?customer_id=12&summary=true', this.setData)
            // I _THINK_ this can be done here (it might need to be done after the data is received)
            this.currentListType = val.listType
            this.currentListId = null
          }
        } else {
          console.log('DT ERROR DashboardTable.watch location unexpected listType:', val)
        }

        // this.currentSelId = val.selectedId
      },
    },
  },
  computed: {
    title() {
      switch (this.location.listType) {
        case this.location.TYPE_SITES:
          return this.$t('dashboard.table.titleSites')
        case this.location.TYPE_GWS:
          return this.$t('dashboard.table.titleGws')
        case this.location.TYPE_INVS:
          return this.$t('dashboard.table.titleInvs')
        default:
          return '(unknown)'
      }
    },
    fields() {
      let fields = [
        { name: '__slot:status', dataClass: 'text-center' },
        { name: 'name', title: '' },
      ]

      if (this.currentListType === 'invs' && this.bFilterIssues) {
        fields.push({ name: '__slot:details', title: 'Last Contact', dataClass: 'text-right-nowrap' })
      } else {
        fields.push({ name: '__slot:icon', dataClass: 'text-center' })
        fields.push({ name: '__slot:power', title: '', dataClass: 'text-right-nowrap' })
      }
      if (this.currentListType !== 'invs') {
        fields.push({ name: '__slot:extlink', title: '', dataClass: 'text-right' })
      }
      return fields
      // these fields can be included in any of the fields above:
      // title: this.$t('tables.headings.status'),
      // width: '20%',
      //   name: '__slot:goto',
      // sortField: 'status',
    },
    filterIssues() {
      return [
        {
          value: 0,
          label: 'All', // this.$t('dashboard.table.brief'),
        },
        {
          value: 1,
          label: 'Issues', // this.$t('dashboard.table.detailed'),
        },
      ]
    },
    filteredData() {
      let data = this.listData

      // Issues-only filtering
      if (this.bFilterIssues) {
        if (this.location.listType === 'invs') {
          data = data.filter((item) => {
            return ['fault', 'no-contact', 'locked', 'fault-locked'].includes(item.last_state)
          })
        } else {
          data = data.filter((item) => {
            return item.error_count > 0
          })
        }
      }

      if (!this.searchTerm || this.searchTerm.length < 1) {
        return data
      }

      return data.filter((item) => {
        return item.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1
      })
    },
  },

  /* Selection flow:
      If a user selects an item in a list:
        - Vuetable.onRowClicked:
            rsSelect(item id) // makes the item look selected
            $emit(rowClicked()) -> VaDataTable.rowClicked():
                $emit(rowClicked()) -> DashboardTable.rowClicked():
                    $emit(rowClicked()) -> Dashboard.rowClicked():
                      router.push(new route with selected item id)
                        (continues in next step at dashboard.watch($route))

      If user navigates to a selected item (or bookmark or <back> in browser):
        - dashboard.watch($route)
            dashboard.updateLocation() - splits url into dashboard.location
                dashboard.location is prop for BreadCrumb (which updates the breadcrumb on the screen)
                dashboard.location is prop for DashboardTable
                  DashbardTable
                dashboard.location is a prop for DashboardCharts

  */
  methods: {
    announceNewSelection(selectedItem, selectedId) {
      // selectedItem OR selectedId can be specified (but not both)
      // if selectedId is specified, it will be used to lookup the selectedItem

      if (!selectedItem && selectedId) {
        let selId = parseInt(selectedId) // it is a string
        selectedItem = this.listData.find((item) => item.item_id === selId)
      }
      console.log('DT announce: sItem=', selectedItem)
      console.log('               sId=', selectedId)
      console.log('                dt=', this.$refs.datatable)
      this.$nextTick(() => {
        // datatable isn't loaded yet on the first go-round, so just do it next time (user will not notice)
        if (this.$refs.datatable) {
          this.$refs.datatable.selectRow(selectedId)
          console.log('NEXT TICK: ', this.$refs.datatable)
        }
      })

      // send summary data up to dashboard so it can be propogated to DashboardInfoBlock
      if (selectedItem) {
        this.$emit('setListDataSummary', selectedItem)
      } else {
        this.$emit('setListDataSummary', this.summaryData)
      }
      window.scrollTo(0, 0)
    },

    getStatusColor(item) {
      if (item.item_type === 'inv') {
        return getInvStateColor(item.last_state)
      }
      if (item.item_type === 'site' && item.invs_total === 0) {
        return 'warning'
      }
      if (item.error_count > 0) {
        return 'danger'
      }
      return 'success'
    },
    getStatusText(item) {
      if (item.item_type === 'inv') {
        return item.last_state
      }
      if (item.item_type === 'site' && item.invs_total === 0) {
        if (item.paid_thru_expired && this.$cookie.get('qea') !== 'true') {
          return ''
        } else {
          return 'No invs'
        }
      }
      if (item.error_count > 0) {
        return 'Issues'
      }
      return 'OK'
    },
    getIconName(icon) {
      switch (icon) {
        case 'clear-day':
          return 'sun'
        case 'clear-night':
          return 'moon'
        case 'cloudy':
        case 'fog':
          return 'cloud'
        case 'partly-cloudy-day':
          return 'cloud-sun'
        case 'partly-cloudy-night':
          return 'cloud-moon'
        case 'rain':
          return 'cloud-rain'
        case 'sleet':
        case 'snow':
          return 'cloud-showers-heavy'
        case 'wind':
          return 'wind'
        default:
          return 'question'
      }
    },
    buildGotoLink(props) {
      return { name: 'dashboard_site-gw-invs', params: { siteId: 124, gwSerial: 222, invSerial: 8 } }
    },
    formatPower(item) {
      if (item.paid_thru_expired && this.$cookie.get('qea') !== 'true') {
        return ('<span style="color:red">(Unpaid)</span>')
      }
      let power = 0
      if (item.item_type === 'inv') {
        power = item.last_output_watts
        if (power < 1000) { power = 0 }
      } else {
        power = item.power
      }
      return formatPower(power)
    },
    formatDetails(item) {
      return formatDate(item.last_contact_date)

      // switch (item.last_state) {
      //   case 'fault':
      //   case 'fault-locked':
      //   case 'no-contact':
      //     return formatDate(item.last_contact_date)
      //   case 'locked':
      //     return ''
      //   default:
      //     console.log("ERROR in DT.formatDetails, item.last_state=", item.last_state)
      //     return ''
      // }
    },
    resolveUser(user) {
      console.log('DT resolveUser:')
      console.log(user)

      this.loading = true

      setTimeout(() => {
        const idx = this.users.findIndex((u) => u.id === user.id)
        this.users.splice(idx, 1)
        this.loading = false

        this.showToast(this.$t('dashboard.table.resolved'), {
          icon: 'fa-check',
          position: 'bottom-right',
          duration: 1500,
        })
      }, 500)
    },
    rowClicked(item) {
      console.log('**************************************** DT CLICK ON ', item)

      if (!item) {
        return
      }
      // "navigate" to the selected item. We use the router so that the user
      // can use the <back> button to move back. This will cause Dasboard's updateLocation()
      // to be called to propogate the new selection.
      if (item === null) {
        return
      }
      let name = null
      let params = null
      switch (item.item_type) {
        case 'site':
          name = 'dashboard_sites'
          params = { siteId: item.id }
          break
        case 'gw':
          name = 'dashboard_site-gws'
          params = { siteId: item.site_id, gwSerial: item.serial }
          break
        case 'inv':
          name = 'dashboard_site-gw-invs'
          params = {
            siteId: item.last_site_id,
            gwSerial: item.last_gw_serial,
            invSerial: item.serial,
          }
          break
        default:
          console.log('DT ERROR: unknown selected item:', item)
      }

      this.$router.push({ name: name, params: params }).catch((err) => {
        if (err.name !== 'NavigationDuplicated') {
          console.log('DT PUSH ERROR:', err)
        }
      })
    },
    rowDoubleClicked(item) {
      console.log('**************************************** DT DBL CLICK ON ', item)
      console.log(this.genLinkData(item))
      if (item.item_type === 'site' && item.invs_total === 0 && this.$cookie.get('qea') !== 'true') {
        console.log('DT Not opening site with no inverters')
        this.showToast('Not showing details for sites with no inverters')
        return
      }
      if (item.item_type === 'site' && item.paid_thru_expired && this.$cookie.get('qea') !== 'true') {
        console.log('DT Not opening site with paid-thru-expired')
        this.showToast('Site not paid')
        return
      }
      this.$router.push(this.genLinkData(item))
    },
    cellClicked(item, field) {
      // clicking on extlink has the same effect as double-clicking
      if (field.name === '__slot:extlink' && (!item.paid_thru_expired || this.$cookie.get('qea') === 'true')) {
        console.log('**************************************** DT CELL CLICK ON ', item)
        this.rowDoubleClicked(item)
      }
    },

    genLinkData(item) {
      // Generate the data for a router-link "to" to navigate to the item

      if (item.item_type === 'site') {
        return {
          name: 'dashboard_site-gws',
          params: { siteId: item.id, gwSerial: 0 },
        }
      }

      if (item.item_type === 'gw') {
        return {
          name: 'dashboard_site-gw-invs',
          params: {
            siteId: item.site_id,
            gwSerial: item.serial,
            invSerial: 0,
          },
        }
      }

      if (item.item_type === 'inv') {
        return {}
      }
      console.log('DT ERROR unexpected item_type in genLinkData', item)
    },
    sortCompareName(a, b) {
      const aa = a.name.toLowerCase()
      const bb = b.name.toLowerCase()

      if (aa > bb) {
        return 1
      }
      if (bb > aa) {
        return -1
      }
      return 0
    },

    setData(newval) {
      this.loading = false
      this.listData = newval.items
      this.listData.sort(this.sortCompareName)
      this.summaryData = newval.summary
      let selItem = null

      if (this.listData.length > 0) {
        // if there is no selection, select the first item (rowClicked() will (eventually) cause annonceNewSelection)

        if (!this.location.selectedId) {
          this.rowClicked(this.listData[0])
          return
        }

        // There is a current selection so mark that item as selected

        selItem = this.listData.find((item) => item.item_id === this.location.selectedId)

        if (selItem) {
          selItem.initiallySelected = true
        } else {
          console.log('DT ERROR in setData - item not found, first one selected instead')
          this.rowClicked(this.listData[0])
          return
        }
      }
      this.announceNewSelection(selItem, null)
      console.log('DT SET DATA: ', newval)
    },
    search: debounce(function(searchTerm) {
      this.searchTerm = searchTerm
    }, 400),
  },
  mounted() {
    // console.log('mounted ----------------------------------')
    // get list of sites for searching
    // hiqapi.getcb("/sites?customer_id=2", this.setData)
    // this.siteData = []
    this.isLoading = true
    // // hiqapi.getcb('/sites?customer_id=12&summary=true', this.setData)
    // console.log("============================= ", this.$refs.datatable)
    // this.$refs.datatable.selectRow(location.selectedId)
  },
}
</script>

<style lang="scss">
.font-awesome-icon {
  color: #bebebe;
}
.hiq-spinner-div {
  display: flex;
  justify-content: center;
  padding: 30px;
}
.hiq-spinner {
  animation-duration: 1.5s;
  animation-timing-function: cubic-bezier(0.54, 0.18, 0.46, 0.82);
  animation-delay: 0s;
  animation-iteration-count: infinite;
  animation-direction: normal;
  animation-fill-mode: none;
  animation-play-state: running;
  animation-name: spinner-rotation;
}
@keyframes spinner-rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
  }
}
.extlink {
  color: #7596fb;
}
.extlink:hover {
  color: #0c30d3;
}
.extlink-unpaid {
  color: red;
}
</style>
